<template>
  <div>
    <div class="mb-3 text-muted" v-if="answer.reviewed">
      <small>
        <i class="fa fa-clock"></i>
        {{ stringToPrettyDateTime(answer.reviewed) }}
      </small>
    </div>
    <div
      v-if="renderType === 'stars'"
      class="text-center"
    >
      <span class="badge bg-light">
        <i class="fa fa-star"></i> {{ answer.value_num }}
      </span>
    </div>
    <div v-else-if="renderType === 'check_boxes'">
      <div
        v-for="value in answer.value_list"
        :key="value"
      >
        <i class="fa fa-check-square"></i> {{ showChoiceValue(value) }}
      </div>
      <div
        class="badge badge-default mr-3"
        v-if="answer.value_alt"
      >
        {{ answer.value_alt }}
        <i
          class="ml-1 fa fa-info-circle"
          v-title="$t('sentence.filled_in_else_namely')"
        ></i>
      </div>
    </div>
    <div v-else>
      <div v-if="answer.value_cleaned" class="font-italic">
        {{ answer.value_cleaned }}
        <small class="text-muted"><em>{{ $t('word.edited') }}</em></small>
      </div>
      <div
        v-else-if="renderType === 'radio_buttons'"
      >
        <i class="fa fa-circle-dot"></i>
        {{ showChoiceValue(answer.value_str) }}
      </div>

      <div v-else-if="answer.value_str">
        {{ answer.value_str }}
      </div>

      <div v-if="answer.value_alt">
        {{ answer.value_alt }}
        <i
          class="ml-1 fa fa-info-circle"
          v-title="$t('sentence.filled_in_else_namely')"
        ></i>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <v-button
        v-if="answer.value_cleaned"
        :icon="showOriginal ? 'chevron-down' : 'chevron-right'"
        text="phrase.original_value"
        style-type="link"
        size="xs"
        @click="showOriginal = !showOriginal"
      />
    </div>
    <v-collapse-transition>
      <div v-if="showOriginal">
        <div class="mt-3 mb-0 alert alert-secondary alert-light">
          <h6>{{ $t('phrase.original_value') }}</h6>
          {{ answer.value_str }}
        </div>
      </div>
    </v-collapse-transition>
  </div>
</template>

<script>
import { stringToPrettyDateTime } from '@/common/utils/formatting';
import Button from '@/common/components/Button.vue';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';
import { EXCLUSIVE_RESPONSE_OPTIONS } from '@/common/services/items';


export default {
  name: 'RawDataView',
  components: {
    'v-button': Button,
    'v-collapse-transition': CollapseTransition,
  },
  data() {
    return {
      showOriginal: false,
    };
  },
  props: {
    answer: {
      type: Object,
      required: true,
    },
    renderType: {
      type: String,
      required: true,
    },
  },
  methods: {
    stringToPrettyDateTime,
    showChoiceValue(value) {
      if (Object.keys(EXCLUSIVE_RESPONSE_OPTIONS).includes(value)) {
        return this.$t(EXCLUSIVE_RESPONSE_OPTIONS[value]);
      }
      return value;
    },
  },
};
</script>
